import { render } from "./BlockTrain.html?vue&type=template&id=7b8343ed&ts=true&external"
import script from "./BlockTrain.vue?vue&type=script&lang=ts"
export * from "./BlockTrain.vue?vue&type=script&lang=ts"

import "./BlockTrain.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__